import { Breadcrumb } from "react-bootstrap";
import MaterialTypeForm from "./Form";
import { Link } from "react-router-dom";

const EditMaterialType = () => {
  return (
    <div>
      <h1>Edit MaterialType</h1>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin" }}>
          Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Master</Breadcrumb.Item>
        <Breadcrumb.Item active>Edit MaterialType</Breadcrumb.Item>
      </Breadcrumb>

      <MaterialTypeForm />
    </div>
  );
};

export default EditMaterialType;
